/**
 * Created by glenn on 7/25/2017.
 */
import Redux = require("redux");
import * as apiNpmrdsStore from '../../api/npmrds/npmrdsStore';
import * as apiActions from '../../api/npmrds/actions';
import * as heatmapActions from './actions';
import LayerBaseVectorGeoJson from 'webmapsjs/dist/layers/LayerBaseVectorGeoJson';
import {emptyRoute} from 'webmapsjs/dist/api/_npmrdsEmpty';
import {iRoute, iRoad} from 'webmapsjs/dist/api/_npmrdsInterfaces';
import SortedFeatures from 'webmapsjs/dist/olHelpers/SortedFeatures';
import Map from 'ol/Map';
import {keyValPairs} from 'webmapsjs/dist/util/objectHelpers';

export interface iState {
    map: Map;
    extent: apiNpmrdsStore.iExtentInner;
    roads: iRoad[];
    roadIndex: number;
    layers: { line: LayerBaseVectorGeoJson, point: LayerBaseVectorGeoJson, tracker: LayerBaseVectorGeoJson };
    startEndDate: { start: Date, end: Date, version: number};
    data: iRoute;
    slider: number;
    sorted: SortedFeatures;
    vehicle: string;
    waiting: boolean;
}

interface iSetMap extends Redux.Action {
    map: Map;
}

interface iSetVersion extends Redux.Action {
    version: number;
}

interface iWaiting extends Redux.Action {
    waiting: boolean;
}

interface iSetVehicle extends Redux.Action {
    vehicle: string;
}

interface iSetRoads extends Redux.Action {
    roads: iRoad[];
}

interface iSetSorted extends Redux.Action {
    sorted: SortedFeatures;
}

interface iSetLayers extends Redux.Action {
    point: LayerBaseVectorGeoJson;
    line: LayerBaseVectorGeoJson;
    tracker: LayerBaseVectorGeoJson;
}

interface iSetData extends Redux.Action {
    data: iRoute;
}

interface iSetSlider extends Redux.Action {
    slider: number;
}

let defaultSorted = new SortedFeatures([], 'pnct');

function reduceSorted(state = defaultSorted, action: iSetSorted) {
    if (action.type == heatmapActions.ACTION_SET_SORTED) {
        return action.sorted || defaultSorted;
    } else {
        return state
    }
}

function reduceVehicles(state='All', action: iSetVehicle){
    if (action.type == heatmapActions.ACTION_SET_VEHICLE){
        return action.vehicle;
    } else {
        return state;
    }
}

function waiting(state=false, action: iWaiting){
    if (action.type == heatmapActions.ACTION_SET_WAITING){
        return action.waiting;
    } else {
        return state;
    }
}

function reduceLayers(state = {point: null, line: null, tracker: null}, action: iSetLayers) {
    if (action.type == heatmapActions.ACTION_SET_LAYERS) {
        return {point: action.point, line: action.line, tracker: action.tracker}
    } else {
        return state;
    }
}

function reduceSlider(state = 0, action: iSetSlider) {
    if (action.type == heatmapActions.ACTION_SET_SLIDER) {
        return action.slider
    } else {
        return state;
    }
}

function reduceMap(state = null, action: iSetMap) {
    if (action.type == heatmapActions.ACTION_SET_MAP) {
        return action.map;
    } else {
        return state
    }
}

function reduceRoads(state = [], action: iSetRoads) {
    if (action.type == heatmapActions.ACTION_SET_ROADS) {
        return action.roads;
    } else {
        return state
    }
}

function reduceData(state = emptyRoute, action: iSetData) {
    if (action.type == heatmapActions.ACTION_SET_DATA) {

        for (let kv of keyValPairs(action.data.roads)){
            action.data.speed['tmcs'] = kv.value['tmcs'];
            break;
        }
        return action.data;
    } else {
        return state
    }
}

export const store = Redux.createStore(
    Redux.combineReducers(
        {
            map: reduceMap,
            extent: apiNpmrdsStore.extent,
            roads: reduceRoads,
            roadIndex: apiNpmrdsStore.roadIndex,
            startEndDate: apiNpmrdsStore.startEndDate,
            waiting: apiNpmrdsStore.waiting,
            layers: reduceLayers,
            data: reduceData,
            slider: reduceSlider,
            sorted: reduceSorted,
            vehicle: reduceVehicles,
        }
    )
);

export function setVehicles(veh: string){
    store.dispatch({type: heatmapActions.ACTION_SET_VEHICLE, vehicle: veh});
}

export function setLayers(line: LayerBaseVectorGeoJson, point: LayerBaseVectorGeoJson, tracker: LayerBaseVectorGeoJson) {
    store.dispatch({type: heatmapActions.ACTION_SET_LAYERS, line: line, point: point, tracker: tracker})
}

export function setMap(map: Map) {
    store.dispatch({type: heatmapActions.ACTION_SET_MAP, map: map})
}

function _extract_road(roadName: string): number{

    let r = roadName.match(/\S*-\d*/);

    if(!r){
        return -1;
    }

    if (r.length > 0){
        let roadNum = parseInt(roadName.split('-')[1]);
        return roadNum % 2;
    } else {
        return -1;
    }
}

export function setRoads(roads: iRoad[]) {

    let roadsFix: iRoad[] = [];

    for (let r of roads){

        if (!r.number){
            continue;
        }

        let key = _extract_road(r.number);

        let dir = r.direction.toLowerCase()[0];

        switch (key) {
            case 0:
                if (dir === 'e' || dir === 'w'){
                    //pass
                } else {
                    continue;
                }
                break;
            case 1:
                if (dir === 'n' || dir === 's'){
                    //pass
                } else {
                    continue;
                }
                break;
            default:
                break;
                //pass
        }

        roadsFix.push(r);
    }

    store.dispatch({type: heatmapActions.ACTION_SET_ROADS, roads: roadsFix});

    if (roads.length > 0) {
        store.dispatch({type: apiActions.ACTION_SET_ROAD_INDEX, roadIndex: 0})
    } else {
        store.dispatch({type: apiActions.ACTION_SET_ROAD_INDEX, roadIndex: -1})
    }

}

export function setSlider(d: number): any {
    store.dispatch({type: heatmapActions.ACTION_SET_SLIDER, slider: d});

    let state: iState = store.getState() as iState;

    state.layers.tracker.clear();
    let feat = state.sorted.getFeature(state.slider / 100);

    if (feat) {
        state.layers.tracker.source.addFeature(feat);
    }
}

export function setData(d: iRoute = emptyRoute) {
    store.dispatch({type: heatmapActions.ACTION_SET_DATA, data: d});

    let state = store.getState() as iState;

    if (!state.layers.line){
        return;
    }

    state.layers.line.clear();
    state.layers.point.clear();
    state.layers.tracker.clear();

    if (d.line.features.length > 0) {
        state.layers.line.addFeatures(d.line);
    }

    if (d.points.features.length > 0) {
        state.layers.point.addFeatures(d.points);
        let sorted = new SortedFeatures(state.layers.point.source.getFeatures(), 'pnct');
        store.dispatch({type: heatmapActions.ACTION_SET_SORTED, sorted: sorted});

        let feat = sorted.getFeature(state.slider / 100);

        if (feat) {
            state.layers.tracker.source.addFeature(feat);
        }
    } else {
        store.dispatch({type: heatmapActions.ACTION_SET_SORTED})
    }
}
